import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScrollLockService {
  public isLocked: boolean = false;
  private document = inject(DOCUMENT);

  public lock(): void {
    this.document.body.style.overflow = 'hidden';
    this.isLocked = true;
  }

  public unlock(): void {
    if (!this.isLocked) {
      return;
    }
    this.document.body.style.overflow = '';
    this.isLocked = false;
  }
}
